import { ROUTES } from "@/consts";
import { TAgeFilter, TMultiTrackEntry, TTrackTypes } from "@/types";

export type AgeGroupKey = "15+" | "10-14" | "JUNIOR_TRACK" | "MINI_TRACK";

interface AgeGroupSelectionConfig {
  ageGroup: TAgeFilter;
  trackType: TTrackTypes;
  route: string;
}

export const AGE_GROUP_KEYS: readonly AgeGroupKey[] = ["15+", "10-14", "JUNIOR_TRACK", "MINI_TRACK"];

export const AGE_GROUP_CONFIG: Record<AgeGroupKey, AgeGroupSelectionConfig> = {
  "15+": { ageGroup: "15+", trackType: "MAIN_TRACK", route: ROUTES.MAIN_TRACK.SEATS_RACES },
  "10-14": { ageGroup: "10-14", trackType: "INTERMEDIATE_TRACK", route: ROUTES.INTERMEDIATE_TRACK.SEATS_RACES },
  JUNIOR_TRACK: { ageGroup: "Under 11" as TAgeFilter, trackType: "JUNIOR_TRACK", route: ROUTES.JUNIOR_TRACK.SEATS_RACES },
  MINI_TRACK: { ageGroup: "Under 11" as TAgeFilter, trackType: "MINI_TRACK", route: ROUTES.MINI_TRACK.SEATS_RACES },
};

export const isAgeGroupKey = (key: string): key is AgeGroupKey => key in AGE_GROUP_CONFIG;

export const getFirstSelectedAgeGroup = (selectedKeys: ReadonlySet<string>): AgeGroupKey | null =>
  AGE_GROUP_KEYS.find((key) => selectedKeys.has(key)) ?? null;

export const buildRacingMultiTrackEntries = (
  selectedKeys: ReadonlySet<string>,
  includeBattleKart: boolean | string | undefined,
): TMultiTrackEntry[] => {
  const entries: TMultiTrackEntry[] = AGE_GROUP_KEYS.filter((key) => selectedKeys.has(key)).map((key) => {
    const config = AGE_GROUP_CONFIG[key];
    return {
      key,
      trackType: config.trackType,
      ageGroup: config.ageGroup,
      route: config.route,
    };
  });

  if (includeBattleKart) {
    entries.push({
      key: "BATTLE_KART",
      trackType: "BATTLE_KART_TRACK",
      ageGroup: null,
      route: ROUTES.BATTLE_KART_TRACK.PLAYERS_SESSIONS,
    });
  }

  return entries;
};
